<template>
  <v-menu
    :ref="extPicker.menu"
    v-model="extPicker.menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="extPicker.birthdate"
        :label="label"
        hint="DD/MM/YYYY"
        persistent-hint
        :prepend-icon="$vuetify.breakpoint.smAndUp ? 'mdi-calendar' : ''"
        v-bind="attrs"
        @blur="updateDate(extPicker)"
        v-on="on"
        clearable
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="extPicker.rawdate"
      no-title
      @input="closeMenu(extPicker)"
    ></v-date-picker>
  </v-menu>
</template>

<script>

export default {
  name: 'DatePicker',
  props: {
    picker: Object,
    label: String
  },
  data: vm => ({
    extPicker: {}
  }),
  mounted() {
    this.extPicker = this.picker
  },
  methods: {
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    closeMenu (picker) {
      picker.menu = false
      picker.birthdate = this.formatDate(picker.rawdate)
    },
    updateDate (picker) {
      picker.rawdate = this.parseDate(picker.birthdate)
    }
  },
  watch: {
    'picker.birthdate': function (val) {
      this.extPicker.birthdate = val
    }
  },
  newPickerObject: function () {
    return {
      birthdate: '',
      menu: '',
      rawdate: ''
    }
  }
}
</script>
